// Persisted microphone selection (mic-health sprint). The operator picks an
// input device in the header; the choice survives reloads so Friday's hearing
// uses the same headset that was rehearsed with. An empty/absent value means
// "system default".

const MIC_DEVICE_STORAGE_KEY = 'cc_mic_device_id';

export function getPreferredMicDeviceId(): string | null {
  try {
    const raw = window.localStorage.getItem(MIC_DEVICE_STORAGE_KEY);
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

export function setPreferredMicDeviceId(deviceId: string | null): void {
  try {
    if (deviceId) {
      window.localStorage.setItem(MIC_DEVICE_STORAGE_KEY, deviceId);
    } else {
      window.localStorage.removeItem(MIC_DEVICE_STORAGE_KEY);
    }
  } catch {
    // localStorage may be unavailable; the choice just won't persist.
  }
}
